'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { connect } = require('preact-redux');

const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const redemptionHandler = require('../../support/redemption-handler');
const { publish } = require('../../support/event-observer');
const { getReferralSource } = require('../../support/redemption-helper');

function getAnchorContent(className, offerType) {
  if (className === 'coupon-tile-background') {
    return null;
  }

  return OfferRedemptionText({
    type: offerType,
  });
}

function CouponButton({
  coupon,
  routes,
  className = '',
  referralSource,
  directRedemption,
}) {
  const { offerId, offerType } = coupon;

  referralSource = getReferralSource({
    referralSource,
    offerId,
    directRedemption,
  });

  const clickRedemptionHandler = () =>
    redemptionHandler({
      routes,
      offerId,
      referralSource,
    }).then(data => publish('@redemption', data));

  const keyUpRedemptionHandler = ev => {
    if (ev.keyCode === 13) {
      clickRedemptionHandler();
    }
  };

  return h(
    `a.${className}`,
    {
      tabindex: 0,
      onClick: clickRedemptionHandler,
      onKeyUp: keyUpRedemptionHandler,
      'data-bhc': `coupon:${offerId}`,
      'data-bhd': JSON.stringify({ type: offerType }),
    },
    getAnchorContent(className, offerType)
  );
}

const mapStateToProps = state => ({
  referralSource: state.referralSource,
  directRedemption: state.directRedemption,
  showDisruptor: state.showDisruptor,
});

module.exports = connect(mapStateToProps)(
  hydrate('CouponButton', CouponButton)
);
